// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1Y1oH","icon":"Radio_icon__3NYGw","labelText":"Radio_labelText__2I_vR"};